import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import './EmptyState.scss'
const EmptyState = memo(({ description, onRefresh }) => {
  const { t } = useTranslation()

  return (
    <div className="ai-credit-empty-state" role="status" aria-live="polite">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          description || t('reports:no_data_found') || 'No data found'
        }
      >
        {onRefresh && (
          <button
            className="ant-btn ant-btn-primary"
            onClick={onRefresh}
            aria-label="Refresh data"
          >
            {t('buttons:refresh') || 'Refresh'}
          </button>
        )}
      </Empty>
    </div>
  )
})

EmptyState.propTypes = {
  description: PropTypes.string,
  onRefresh: PropTypes.func
}

EmptyState.displayName = 'EmptyState'

export default EmptyState
